import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, articles, works, photobooks, featuredArticles } from '@/mocks/arina';

function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20abstract%20background%20with%20soft%20warm%20rose%20gold%20and%20cream%20gradient%2C%20delicate%20sakura%20petals%20floating%2C%20dreamy%20soft%20focus%2C%20artistic%20composition%2C%20luxurious%20texture%2C%20warm%20gentle%20lighting%2C%20Japanese%20aesthetic&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="桥本有菜官方资料站"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 text-center">
        <p className="text-sm md:text-base text-white/80 font-body tracking-widest mb-4">
          HASHIMOTO ARINA OFFICIAL FAN SITE
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
          桥本有菜
        </h1>
        <p className="text-base md:text-lg text-white/70 font-body max-w-xl mx-auto leading-relaxed mb-8">
          日本知名女演员与偶像，以清纯甜美的外表与出色的演技深受粉丝喜爱。
          本站全面汇总桥本有菜的个人资料、出道经历、代表作品、写真集及最新动态。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/profile"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解详情
          </Link>
          <Link
            to="/category/news"
            className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            最新动态
          </Link>
        </div>
      </div>
    </section>
  );
}

function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            探索桥本有菜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            从个人资料到最新动态，全方位了解桥本有菜的魅力
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 whitespace-nowrap transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedArticlesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">桥本有菜最新最热门的深度内容</p>
          </div>
          <Link
            to="/category/news"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2 py-0.5 bg-primary-50 text-primary-600 text-xs rounded-full whitespace-nowrap">
                    {categories.find((c) => c.slug === article.category)?.name}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function WorksSection() {
  const [activeTab, setActiveTab] = useState('all');
  const tabs = [
    { key: 'all', label: '全部' },
    { key: '影视作品', label: '影视作品' },
    { key: '电视剧', label: '电视剧' },
    { key: '综艺节目', label: '综艺节目' },
    { key: '广播节目', label: '广播节目' },
  ];
  const filteredWorks =
    activeTab === 'all' ? works : works.filter((w) => w.type === activeTab);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            代表作品
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            桥本有菜出道以来的精彩作品一览
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === tab.key
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filteredWorks.map((work) => (
            <div
              key={work.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 transition-all duration-300"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={work.coverImage}
                  alt={work.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700 rounded-full whitespace-nowrap">
                  {work.type}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900 mb-1">{work.title}</h3>
                <p className="text-xs text-foreground-400 mb-2">{work.year}</p>
                <p className="text-sm text-foreground-500 line-clamp-2">{work.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function PhotobookSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-2">
              写真集
            </h2>
            <p className="text-sm text-foreground-500">桥本有菜的写真集作品</p>
          </div>
          <Link
            to="/category/photobook"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {photobooks.map((pb) => (
            <Link
              key={pb.id}
              to="/category/photobook"
              className="group cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={pb.coverImage}
                  alt={pb.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors text-center">
                {pb.title}
              </h3>
              <p className="text-xs text-foreground-400 text-center mt-1">{pb.releaseDate}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot && honeypot.value.trim()) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }
    const formData = new FormData(form);
    try {
      const res = await fetch('https://readdy.ai/api/form/d9sr1ed8o1vn02ekukog', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || text;
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后重试。');
        } else {
          setStatus('error');
          setMessage('提交失败，请稍后重试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-2xl mx-auto px-6 text-center">
        <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
          订阅最新资讯
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-md mx-auto">
          第一时间获取桥本有菜的最新动态、作品发布和粉丝活动信息
        </p>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          data-readdy-form=""
        >
          <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="anti-spam-field" />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
          />
          <button
            type="submit"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </button>
        </form>
        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-green-600' : 'text-red-500'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '桥本有菜官方资料站',
    url: 'https://hashimoto-arina.com',
    description: '桥本有菜是备受关注的日本女演员与偶像，本站全面汇总桥本有菜的个人资料、出道经历、代表作品、写真集及最新动态。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hashimoto-arina.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '桥本有菜官方资料站',
    url: 'https://hashimoto-arina.com',
    description: '华语地区最全面的桥本有菜资讯平台',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@hashimoto-arina.com',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedArticlesSection />
          <WorksSection />
          <PhotobookSection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}